
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
:host {

    position: relative;

    margin: 0px;

    display: block;

    height: 3.5rem;

    background-color: var(--primary-blue-dark)
}

@media (min-width: 1280px) {

    :host {

        margin: 1.25rem
    }

    :host {

        height: auto
    }

    :host {

        background-color: var(--neutral-transparent)
    }
}

.newco-text {

    position: absolute;

    margin: auto;

    display: flex;

    height: 100%;

    width: 100%;

    align-items: center;

    justify-content: space-between;

    padding-left: 2rem;

    padding-right: 2rem;

    text-align: center;

    font-family: var(--ff-body);

    font-weight: var(--fw-bold);

    color: var(--neutral-white)
}

@media (min-width: 1280px) {

    .newco-text {

        justify-content: space-around
    }

    .newco-text {

        padding-left: 0.75rem
    }

    .newco-text {

        padding-right: 0px
    }
}

.icon {

    width: 1.25rem
}

svg {

    display: none
}

@media (min-width: 1280px) {

    svg {

        display: block
    }
}
`;